<template>
    <div class="text-center">
        <v-dialog
            :value="isVisible"
            @click:outside="$emit('close')"
            @keydown.esc="$emit('close')"
            max-width="1200px"
        >
            <v-card>
                <v-card-title>
                    <slot name="title">Entity History</slot>
                </v-card-title>

                <v-card-text>
                    <v-simple-table v-if="histories.length">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left" width="15%">
                                        Created
                                    </th>
                                    <th class="text-left" width="15%">
                                        Created By
                                    </th>
                                    <th class="text-left" width="10%">
                                        Type
                                    </th>
                                    <th class="text-left" width="60%">
                                        Changes
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="history in histories"
                                    :key="history._id"
                                >
                                    <td>{{
                                        history.created
                                            | dateTimeFormatFromSettings
                                    }}</td>
                                    <td>
                                        {{ history.createdBy.fullName }}
                                    </td>
                                    <td>{{ history.type }}</td>
                                    <td>
                                        <div v-if="history.changes">
                                            <dl
                                                v-for="(value, key) in history
                                                    .changes.public"
                                                :key="key"
                                            >
                                                <template v-if="key !== 'id'">
                                                    <dt>{{ key }}</dt>
                                                    <dd>{{ value }}</dd>
                                                </template>
                                            </dl>
                                            <dl
                                                v-for="key in history.changes
                                                    .protected"
                                                :key="key"
                                            >
                                                <dt>{{ key }}</dt>
                                                <dd>** protected **</dd>
                                            </dl>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <div v-else>
                        There's no histories for this entity.
                    </div>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="$emit('close')">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        histories: {
            type: Array,
            required: true
        },
        isVisible: {
            type: Boolean,
            required: true
        }
    }
};
</script>

<style scoped>
dl {
    display: flex;
    flex-wrap: wrap;
    margin: 5px;
}
dt {
    width: 50%;
    font-weight: bold;
}
dt::after {
    content: ':';
}
dd {
    margin-left: auto;
    width: 50%;
}
</style>
